import { useApiList } from "@/queries/base/useApiList";

/**
 * Fetches all Part Details with optional params.
 * GET /part_detail
 *
 * @param {object} params - Query params
 * @param {any} deps - Additional dependencies
 * @returns {{ data: Array, isLoading: boolean }}
 */
export function useAllPartDetails(params = {}, deps = []) {
  const cleanParams = Object.fromEntries(
    Object.entries(params).filter(
      ([, v]) => v !== undefined && v !== null && v !== "",
    ),
  );
  const queryString = new URLSearchParams(cleanParams).toString();
  const resourcePath = queryString
    ? `/part_detail?${queryString}`
    : "/part_detail";

  const { data, isLoading } = useApiList(resourcePath, [deps]);

  return { data, isLoading };
}
